import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    currentTab: {
      purchaseTab: 0,
      inventoryTab: 0,
      inventorySetupTab: 0,
      customerTab: 0,
      supplierTab: 0,
      humanResourceTab: 0,
      settingsTab: 0,
      accountingTab: 0,
      dashboardTab: 0,
      userMangementTab: 0,
      returnTab: 0,
      stockTransferTab:0,
      fileUploadTab: 0
    },
    port: null,
    refreshCount: 0,
  };
  
  const tabSlice = createSlice({
    name: "tabs",
    initialState,
    reducers: {
      setClearTabs: (state) => {
        state.currentTab = {
          purchaseTab: 0,
          inventoryTab: 0,
          inventorySetupTab: 0,
          customerTab: 0,
          supplierTab: 0,
          humanResourceTab: 0,
          settingsTab: 0,
          accountingTab: 0,
          dashboardTab: 0,
          userMangementTab: 0,
          returnTab: 0,
          stockTransferTab:0,
          fileUploadTab: 0
        };
      },
      setCurrentTab: (state, action)=>{
        state.currentTab[action.payload.name] = action.payload.tab;
      },
      setPort: (state, action) => {
        state.port = action.payload
      },
      setRefreshCount: (state) => {
        state.refreshCount = state.refreshCount+1
      }
    },
  });
  
  export const { setClearTabs, setCurrentTab, setPort, setRefreshCount } =
  tabSlice.actions;
  export default tabSlice.reducer;
  